/**
 * Palier de remise par quantité — DOIT rester synchronisé manuellement avec la
 * réduction automatique configurée dans Shopify Admin > Réductions. Si le
 * pourcentage change côté Admin, le modifier ICI uniquement.
 */
var QPS_DISCOUNT_TIERS = {
  '1': 0,
  '4': 10
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quantity-pill-selector]').forEach(function (fieldset) {
    var target = document.getElementById(fieldset.getAttribute('data-quantity-target'));
    var unitPrice = parseInt(fieldset.getAttribute('data-unit-price'), 10);
    var priceContainer = document.getElementById(fieldset.getAttribute('data-price-container'));
    if (!target) return;

    // Repère l'élément de prix visible et mémorise son suffixe d'origine
    // ("EUR", symbole...) une seule fois, sans dupliquer la logique de devise.
    var priceEl = null;
    var priceSuffix = '';
    if (priceContainer && !isNaN(unitPrice)) {
      priceEl = priceContainer.querySelector('.price__regular .price-item--regular');
      if (!priceEl || priceEl.offsetParent === null) {
        priceEl = priceContainer.querySelector('.price__sale .price-item--sale');
      }
      if (priceEl) {
        var match = priceEl.textContent.trim().match(/^(\d+)(.*)$/);
        if (match) priceSuffix = match[2];
      }
    }

    function updatePrice(qty) {
      if (!priceEl) return;
      var discountPercent = QPS_DISCOUNT_TIERS[qty] || 0;
      var totalCents = Math.round(unitPrice * qty * (1 - discountPercent / 100));
      priceEl.textContent = Math.round(totalCents / 100) + priceSuffix;
    }

    fieldset.addEventListener('change', function (event) {
      if (event.target.type !== 'radio') return;
      target.value = event.target.value;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      updatePrice(event.target.value);
    });
  });
});
